import script from "./LiensUtilWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiensUtilWidget.vue?vue&type=script&setup=true&lang=ts"

import "./LiensUtilWidget.vue?vue&type=style&index=0&id=44db0c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44db0c70"]])

export default __exports__